export default "__VITE_ASSET__CexNWlH9__"